import {
  HashRouter,
  Redirect,
  Route,
  RouteProps,
  Switch,
} from 'react-router-dom';
import { isAuthenticated } from '../Services/auth';
import CadImportProducts from '../Pages/Cadastro/CadImportProducts';
import CadImportPrices from '../Pages/Cadastro/CadImportPrices';

import GlobalLayout from '../Components/GlobalLayout';
import Globals from '../Globals.json';
import CadNaturalQuery from '../Pages/Cadastro/CadNaturalQuery';
import CadEmitirNfe from '../Pages/Vendas/CadEmitirNfe';
import CadNotasFiscais from '../Pages/Vendas/CadNotasFiscais';

// Importação de páginas
import Dashboard from '../Pages/dashboard';
import Login from '../Pages/login/index';
import Forgot from '../Pages/forgot';
import Recovery from '../Pages/recovery';
import MyAccount from '../Pages/my-account';

import { v4 as uuidv4 } from 'uuid';

// Importação de todas as páginas privadas
import CadClientes from '../Pages/Cadastro/CadClientes';
import CadFornecedores from '../Pages/Cadastro/CadFornecedor';
import CadFuncionarios from '../Pages/Cadastro/CadFuncionario';
import CadProdutos from '../Pages/Cadastro/CadProdutos';
import CadTransportadoras from '../Pages/Cadastro/CadTransportador';
import CadUnidMedida from '../Pages/Cadastro/CadUnidMedida';
import CadAjustes from '../Pages/Cadastro/CadAjusteEstoque';
import CadBankAccounts from '../Pages/Cadastro/CadBankAccounts';
import CadCategoriaMovimentacao from '../Pages/Cadastro/CadCategoriaMovimentacao';
import CadEstoque from '../Pages/Cadastro/CadLocalEstoque';
import CadFormaPagamento from '../Pages/Cadastro/CadFormaPagamento';
import CadMovimEstoque from '../Pages/Cadastro/CadMovimEstoque';
import CadOrcamentos from '../Pages/Cadastro/CadOrcamentos';
import CadPlanoContas from '../Pages/Cadastro/CadPlanoContas';
import CadPosicoes from '../Pages/Cadastro/CadPosicoes';
import CadProducao from '../Pages/Cadastro/CadProducao';
import CadTabelaPreco from '../Pages/Cadastro/CadTabelaPreco';
import CadTiposMovimentacoes from '../Pages/Cadastro/CadTiposMovimentacoes';
import CadTransfEstoque from '../Pages/Cadastro/CadTransfEstoque';
import CadVendas from '../Pages/Cadastro/CadListagemVendas';
import CadVendaDetalhe from '../Pages/Cadastro/CadVendaDetalhe';
import CadVendasTemporarias from '../Pages/Cadastro/CadListagemVendasTemporarias';
import CadImprimirRecibos from '../Pages/Cadastro/CadImprimirRecibos';
import CadStore from '../Pages/Cadastro/CadStore';
import { CadCategorias } from '../Pages/Cadastro/cadCategorias';
import { CadPerfilFiscal } from '../Pages/Cadastro/CadPerfilFiscal';
import VincularCategoria from '../Pages/VincularCategoria';
import CadRepresentative from '../Pages/dashboard/Admin/CadRepresentative';
import AcessoLoja from '../Pages/Cadastro/AcessoLoja';
import CadFormaRecebimento from '../Pages/Cadastro/CadFormaRecebimento';
import { CardInventario } from '../Pages/Cadastro/CadInventario';
import CadFinanceiroReceita from '../Pages/Cadastro/CadFinanceiroReceita';
import CadFinanceiroDespesa from '../Pages/Cadastro/CadFinanceiroDespesa';
import { CardContagem } from '../Pages/Cadastro/CadContagem';
import CadPerfilUsuario from '../Pages/Cadastro/CadPermissions';
import CadUserSystem from '../Pages/Cadastro/CadUserSystem';
import CadCfops from '../Pages/Cadastro/CadCfops';
import CadPerfilAcesso from '../Pages/Cadastro/CadPerfilAcesso';
import SelfService from '../Pages/Cadastro/CadSelfService';
import CadFormaRecebimentoPDV from '../Pages/Cadastro/CadFormaRecebimentoPDV';
import { CadFichaTecnica } from '../Pages/Cadastro/CadFichaTecnica';
import CopyProductImages from '../Pages/CopyProductImages';

interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <GlobalLayout>
          <Component {...props} />
        </GlobalLayout>
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      )
    }
  />
);

export default function Routes() {
  return (
    <HashRouter>
      <Switch>
        {/* Rotas privadas */}
        <PrivateRoute exact path={Globals.paths.home} component={Dashboard} />
        <PrivateRoute
          exact
          path={Globals.paths.representative}
          component={CadRepresentative}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadStore}
          component={CadStore}
        />
        <PrivateRoute
          exact
          path={Globals.paths.accessStores}
          component={AcessoLoja}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadFornecedores}
          component={CadFornecedores}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadClientes}
          component={CadClientes}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadTransportadoras}
          component={CadTransportadoras}
        />
        <PrivateRoute
          exact
          path={Globals.paths.CadVendas}
          component={CadVendas}
        />
        <PrivateRoute
          exact
          path={Globals.paths.CadVendaDetalhe}
          component={CadVendaDetalhe}
        />
        <PrivateRoute
          exact
          path={Globals.paths.CadVendasTemporarias}
          component={CadVendasTemporarias}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadLocaisEstoque}
          component={CadEstoque}
        />
        <PrivateRoute
          exact
          path={Globals.paths.CadFichaTecnica}
          component={CadFichaTecnica}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadTransferencias}
          component={CadTransfEstoque}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadMovimentacoes}
          component={CadMovimEstoque}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadAjustes}
          component={CadAjustes}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadPosicoes}
          component={CadPosicoes}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadTiposMovimentacoes}
          component={CadTiposMovimentacoes}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadInventario}
          component={CardInventario}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadContagem}
          component={CardContagem}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadOrcamentos}
          component={CadOrcamentos}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadFuncionarios}
          component={CadFuncionarios}
        />
        <PrivateRoute
          exact
          path={Globals.paths.CadUnidMedida}
          component={CadUnidMedida}
        />
        <PrivateRoute
          exact
          path={Globals.paths.CadCatProdutos}
          component={CadCategorias}
        />
        <PrivateRoute
          exact
          path={Globals.paths.CadProdutos}
          component={CadProdutos}
        />
        <PrivateRoute
          exact
          path={Globals.paths.CadPerfilFiscal}
          component={CadPerfilFiscal}
        />
        <PrivateRoute
          exact
          path={Globals.paths.vincularCategoria}
          component={VincularCategoria}
        />
        {/* 🆕 NOVA ROTA - Copiar Imagens de Produtos */}
        <PrivateRoute
          exact
          path={Globals.paths.copyProductImages}
          component={CopyProductImages}
        />
        <PrivateRoute
          exact
          path={Globals.paths.CadProducao}
          component={CadProducao}
        />
        <PrivateRoute
          exact
          path={Globals.paths.CadTabelaPreco}
          component={CadTabelaPreco}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadPlanoContas}
          component={CadPlanoContas}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadFormaRecebimento}
          component={CadFormaRecebimento}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadFormaRecebimentoPDV}
          component={CadFormaRecebimentoPDV}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadFormaPagamento}
          component={CadFormaPagamento}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadCategoriaMovimentacao}
          component={CadCategoriaMovimentacao}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadBankAccounts}
          component={CadBankAccounts}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadImprimirRecibos}
          component={CadImprimirRecibos}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadTransacoesReceitas}
          component={CadFinanceiroReceita}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadTransacoesDespesas}
          component={CadFinanceiroDespesa}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadPerfilUsuario}
          component={CadPerfilUsuario}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadUserSystem}
          component={CadUserSystem}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadRole}
          component={CadPerfilAcesso}
        />
        <PrivateRoute exact path={Globals.paths.Cfops} component={CadCfops} />
        <PrivateRoute
          exact
          path={Globals.paths.selfService}
          component={SelfService}
        />

        <PrivateRoute
          exact
          path={Globals.paths.cadImportProducts}
          component={CadImportProducts}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadImportPrices}
          component={CadImportPrices}
        />
        <PrivateRoute
          exact
          path={Globals.paths.cadNaturalQuery}
          component={CadNaturalQuery}
        />
        <PrivateRoute
          exact
          path={Globals.paths.CadEmitirNfe}
          component={CadEmitirNfe}
        />
        <PrivateRoute
          exact
          path={Globals.paths.CadListarNfe}
          component={CadNotasFiscais}
        />



        {/* Rotas públicas */}
        <Route exact path={Globals.paths.login} component={Login} />
        <Route exact path={Globals.paths.forgot} component={Forgot} />
        <Route exact path={Globals.paths.recovery} component={Recovery} />

        {/* Redireciona para home caso não encontre rota */}
        <Redirect path="*" to={Globals.paths.home} />
      </Switch>
    </HashRouter>
  );
}